import styled from "styled-components";
import CustomIcon from "../Global/Icons/CustomIcon";
import Theme from "../../styles/Theme/Theme";

//If position fixed add width 100%
const BottomBorder = styled.div`
    // position: absolute;
    // bottom: 0;
    display: flex;
    align-items: center;
    background-color: white;
    border-bottom: 5px solid ${Theme.color['green-deloitte']};
    border-top: 1px solid ${Theme.color['neutral-3']};
    // margin-top: auto;
    padding: 0px 0px 0px 64px;
    width: -webkit-fill-available;
    height: 105px;
    min-height: 105px;
`;

export const Footer = () => {
    return(
        <BottomBorder>
            <CustomIcon icon="BrandLogo" width={100} height={35} />
        </BottomBorder>
    )
};